export const filterTemplateData = (data) => {
    const templateData: any = data;
    templateData.category.forEach((item, i) => {
      if (item && item.items && item.items.length > 0) {
        item.items.forEach((subitem) => {
          if (subitem.schema === 'templateStandard') {
            const templateStandardData = templateData.templateStandard.find(
              (templdateStandarditem) => templdateStandarditem.uuid === subitem.id
            );
            if (templateStandardData) {
              const standardData = templateData.standard.find(
                (standardDetail) =>
                  standardDetail.uuid === templateStandardData.standard
              );
              if (standardData) {
                const scoringData = templateData.scoringType.find(
                  (scoringTypeitem) =>
                    scoringTypeitem.uuid === standardData.scoringType
                );
                if (scoringData.id) {
                  subitem.scoringType = scoringData.id;
                  subitem.isVisible = templateStandardData.isVisible;
                } else {
                  templateData.category.slice(i, 1);
                }
              }
            }
          } else {
            subitem.scoringType = -1;
          }
        });
      }
    });
    return templateData;
  };
